var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.filteredCategories),function(category,index){return _c('mag-teaser-articles',{key:category.name,attrs:{"articles":_vm.articlesByCategoryName[category.name] || [],"background":index % 2,"category":category,"id":category.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }